/**
 * Copyright schukai GmbH and contributors 2023. All Rights Reserved.
 * Node module: @schukai/monster
 * This file is licensed under the AGPLv3 License.
 * License text available at https://www.gnu.org/licenses/agpl-3.0.en.html
 */

export { typeOf };

/**
 * The built-in typeof method is known to have some historical weaknesses. This function tries to provide a better and more accurate result.
 *
 * @externalExample ../../example/types/typeof.mjs
 * @param {*} value
 * @return {string}
 * @license AGPLv3
 * @since 1.7.0
 * @copyright schukai GmbH
 * @memberOf Monster.Types
 * @throws {TypeError} value is not a primitive
 */
function typeOf(value) {
	let type = {}.toString.call(value).match(/\s([a-zA-Z]+)/)[1];
	if ("Object" === type) {
		const name = value.constructor.name;
		if (name) {
			return name.toLowerCase();
		}

		const results = /^(class|function)\s+(\w+)/.exec(
			value.constructor.toString(),
		);
		type = results && results.length > 2 ? results[2] : "";
	}

	return type.toLowerCase();
}
